import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-slate-100"
};
const _hoisted_2 = {
  class: "flex items-center gap-3"
};
const _hoisted_3 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_4 = {
  class: "text-xs text-slate-500"
};
const _hoisted_5 = {
  class: "overflow-y-auto max-h-[calc(80vh-140px)] p-6"
};
const _hoisted_6 = {
  key: 0,
  class: "text-center py-12"
};
const _hoisted_7 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_8 = {
  class: "px-4 py-3 bg-slate-50 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_9 = {
  class: "flex items-center gap-3"
};
const _hoisted_10 = {
  class: "font-medium text-slate-700"
};
const _hoisted_11 = {
  class: "text-xs text-slate-400 ml-2"
};
const _hoisted_12 = {
  key: 0,
  class: "divide-y divide-slate-100"
};
const _hoisted_13 = {
  class: "flex items-center gap-3"
};
const _hoisted_14 = {
  class: "flex flex-col"
};
const _hoisted_15 = {
  class: "text-sm text-slate-700"
};
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_17 = {
  class: "flex items-center gap-4"
};
const _hoisted_18 = {
  key: 0,
  class: "text-sm font-medium text-primary-600"
};
const _hoisted_19 = {
  class: "px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-between items-center"
};
const _hoisted_20 = {
  class: "text-sm text-slate-600"
};
const _hoisted_21 = {
  class: "font-semibold text-primary-600"
};
const _hoisted_22 = {
  class: "flex items-center gap-3"
};
import { ref, watch } from 'vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ProductSelector',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '选择授权产品'
    },
    description: {
      type: String,
      default: '选择要授权的产品'
    },
    productTree: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'update:modelValue', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 选中产品
    const selectedIds = ref([]);

    // 监听 modelValue 变化
    watch(() => props.modelValue, val => {
      selectedIds.value = [...val];
    }, {
      immediate: true
    });

    // 关闭弹窗
    const handleClose = () => {
      emit('update:visible', false);
    };

    // 确认选择
    const handleConfirm = () => {
      emit('update:modelValue', [...selectedIds.value]);
      emit('confirm', [...selectedIds.value]);
      handleClose();
    };

    // 全选/取消全选类目下的产品
    const toggleCategoryProducts = (category, checked) => {
      const productIds = category.products.map(p => p.id);
      if (checked) {
        productIds.forEach(id => {
          if (!selectedIds.value.includes(id)) {
            selectedIds.value.push(id);
          }
        });
      } else {
        selectedIds.value = selectedIds.value.filter(id => !productIds.includes(id));
      }
    };

    // 检查是否全选某个类目
    const isCategoryFullySelected = category => {
      if (!category.products || category.products.length === 0) return false;
      return category.products.every(p => selectedIds.value.includes(p.id));
    };

    // 检查是否部分选中某个类目
    const isCategoryPartiallySelected = category => {
      if (!category.products || category.products.length === 0) return false;
      const selectedCount = category.products.filter(p => selectedIds.value.includes(p.id)).length;
      return selectedCount > 0 && selectedCount < category.products.length;
    };

    // 单个产品选择/取消选择
    const handleProductSelect = productId => {
      const index = selectedIds.value.indexOf(productId);
      if (index > -1) {
        selectedIds.value.splice(index, 1);
      } else {
        selectedIds.value.push(productId);
      }
    };

    // 清除所有选择
    const clearSelection = () => {
      selectedIds.value = [];
    };

    // 全选所有产品
    const selectAll = () => {
      props.productTree.forEach(category => {
        if (category.products) {
          category.products.forEach(product => {
            if (!selectedIds.value.includes(product.id)) {
              selectedIds.value.push(product.id);
            }
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_tag = _resolveComponent("el-tag");
      return _openBlock(), _createBlock(_Transition, {
        name: "modal-fade"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.visible,
          size: "3xl",
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "w-10 h-10 bg-gradient-to-br from-primary-100 to-primary-50 rounded-xl flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          })])], -1)), _createElementVNode("div", null, [_createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1)])]), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-all duration-200"
          }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_5, [props.productTree.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
            class: "w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4"
          }, [_createElementVNode("svg", {
            class: "w-8 h-8 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          })])], -1), _createElementVNode("p", {
            class: "text-slate-500"
          }, "暂无可用产品", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productTree, category => {
            return _openBlock(), _createElementBlock("div", {
              key: category.id,
              class: "border border-slate-200 rounded-xl overflow-hidden"
            }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_checkbox, {
              "model-value": isCategoryFullySelected(category),
              indeterminate: isCategoryPartiallySelected(category),
              onChange: val => toggleCategoryProducts(category, val)
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString(category.name), 1), _createElementVNode("span", _hoisted_11, "(" + _toDisplayString(category.products?.length || 0) + "个产品)", 1)]),
              _: 2
            }, 1032, ["model-value", "indeterminate", "onChange"])]), category.status === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "info",
              size: "small"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("停用", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]), category.products && category.products.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.products, product => {
              return _openBlock(), _createElementBlock("div", {
                key: product.id,
                class: "px-4 py-2.5 hover:bg-slate-50 transition-colors flex items-center justify-between"
              }, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_checkbox, {
                "model-value": selectedIds.value.includes(product.id),
                onChange: () => handleProductSelect(product.id)
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(product.name), 1), product.shortName ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(product.shortName), 1)) : _createCommentVNode("", true)])]),
                _: 2
              }, 1032, ["model-value", "onChange"])]), _createElementVNode("div", _hoisted_17, [product.priceDisplay ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(product.priceDisplay), 1)) : _createCommentVNode("", true), product.status === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                type: "info",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("下架", -1)]))]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_tag, {
                key: 2,
                type: "success",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("上架", -1)]))]),
                _: 1
              }))])]);
            }), 128))])) : _createCommentVNode("", true)]);
          }), 128))]))]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[6] || (_cache[6] = _createTextVNode(" 已选择 ", -1)), _createElementVNode("span", _hoisted_21, _toDisplayString(selectedIds.value.length), 1), _cache[7] || (_cache[7] = _createTextVNode(" 个产品 ", -1))]), _createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
            onClick: clearSelection,
            class: "px-4 py-2 text-slate-600 hover:text-slate-800 transition-colors text-sm"
          }, " 清除选择 "), _createElementVNode("button", {
            onClick: selectAll,
            class: "px-4 py-2 text-primary-600 hover:text-primary-700 transition-colors text-sm"
          }, " 全选全部 "), _createElementVNode("button", {
            onClick: handleConfirm,
            class: "px-5 py-2.5 bg-gradient-to-r from-primary-600 to-primary-500 text-white rounded-lg hover:from-primary-700 hover:to-primary-600 shadow-lg shadow-primary-500/25 transition-all duration-200 font-medium"
          }, " 确定 (" + _toDisplayString(selectedIds.value.length) + ") ", 1)])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};